import React, { useState } from "react";
import { IconButton } from "@mui/material";
import { KeyboardArrowDownIcon, KeyboardArrowUpIcon } from "../icons";
import "./PulseExpandPanel.scss";

interface PulseExpandPanelProps {
  title: React.ReactNode;
  children: React.ReactNode;
  defaultExpanded?: boolean;
  className?: string;
}

const PulseExpandPanel: React.FC<PulseExpandPanelProps> = ({
  title,
  children,
  defaultExpanded = false,
  className = "",
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  return (
    <div
      className={`pulse-expand-panel ${isExpanded ? "expanded" : ""} ${className}`}
    >
      <div className="panel-header" onClick={() => setIsExpanded(!isExpanded)}>
        <div className="panel-title">{title}</div>
        <IconButton>
          {isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        </IconButton>
      </div>

      {isExpanded && <div className="panel-content">{children}</div>}
    </div>
  );
};

export default PulseExpandPanel;
